import IframeMessenger from './IframeMessenger'
import Http from './Http'

export default class InFrameComm {
  constructor(options) {
    const http = new Http(options)
    this.messenger = new IframeMessenger({
      onMessage: (callback, request) => {
        http.request(callback, request)
      }
    })
  }
}